import { render, staticRenderFns } from "./ProveedorListSelect.vue?vue&type=template&id=4427a1ee&scoped=true&"
import script from "./ProveedorListSelect.vue?vue&type=script&lang=js&"
export * from "./ProveedorListSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorListSelect.vue?vue&type=style&index=0&id=4427a1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427a1ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemTitle,VProgressCircular,VTextField})
